import { SimpleModal, SimpleModalVariant } from "@repo/ui/Modal/modal";
import type { FC } from "react";

export interface CoachingPlaybookConflictModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Shown when creating or saving a coaching agent is rejected because the chosen
 * playbook already has one (a coaching agent must be unique per playbook). The
 * uniqueness rule is enforced server-side; this is the user-facing backstop.
 */
export const CoachingPlaybookConflictModal: FC<
  CoachingPlaybookConflictModalProps
> = (props) => {
  const { isOpen, onClose } = props;
  return (
    <SimpleModal
      isOpen={isOpen}
      onCancel={onClose}
      onConfirm={onClose}
      variant={SimpleModalVariant.Warning}
      title="Playbook already has a coaching agent"
      subtitle="Each playbook can have only one coaching agent. Pick a different playbook, or edit the existing coaching agent for this playbook."
      confirmButtonText="Got it"
    />
  );
};
